import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { useReactToPrint } from "react-to-print";
import { ApiHook } from "../../hooks/apiHook";
import { useSelector } from "react-redux";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { formatDate } from "../../utils/formateDate";
import DOMPurify from "dompurify";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const PurchaseInvoice = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const tableRef = useRef();
  const invoiceNo = params.id;

  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );
  const userSelectedCurrency = useSelector(
    (state) => state?.user?.selectedCurrency
  );

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  const handleBack = () => {
    navigate("/repurchase-report");
  };

  const downloadPDF = () => {
  const input = document.getElementById("content-to-export"); // The HTML element to export

  html2canvas(input, {
    scale: 2, // Improves quality (optional)
    logging: false,
    useCORS: true, // If your content has external images
  }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4"); // A4 size (210x297mm)

    // Calculate width/height to fit PDF
    const imgWidth = 210; // A4 width in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    pdf.save(`${invoice.data?.clientInfo?.name}.pdf`); // Download PDF
  });
};

  //---------------------------------- API ------------------------------------
  const invoice = ApiHook.CallRepurchaseInvoice(invoiceNo);

  return (
    <>
      <div className="page_head_top">{t("purchase_invoice")}</div>
      <div className="row">
        <div className="col-md-8 m-auto">
          <div className="purchase_invoice" ref={tableRef}>
            <button
              className="print-button"
              style={{ backgroundColor: "white" }}
              onClick={handleBack}
            >
              <i className="fa fa-angle-left" style={{ fontSize: "1.3em" }}></i>
            </button>
            <div className="row p-2">
              <div className="col-md-6 d-flex align-items-center">
                <img src="/images/logo_user.png" alt="" />
              </div>
              <div className="col-md-6 text-end">
                <p className="font-weight-bold mb-1">
                  {`${t("invoice")}: #${invoice.data?.invoiceNo}`}
                </p>
                <p className="text-muted">
                  Date: {formatDate(invoice.data?.date)}
                </p>
                <button
                  type="button"
                  className="btn btn-labeled btn-primary print-button"
                  onClick={handlePrint}
                >
                  <span className="btn-label">
                    <i className="fa fa-print"></i>
                  </span>{" "}
                  {t("print")}
                </button>
              </div>
            </div>

            <hr className="my-1" />

            <div className="row pb-1 p-1">
              <div className="col-md-6">
                <p className="font-weight-bold mb-4">
                  {t("client_information")}
                </p>
                <p className="mb-1">{invoice.data?.clientInfo?.name}</p>
                <p className="mb-1">{invoice.data?.clientInfo?.address}</p>
                <p className="mb-1">{invoice.data?.clientInfo?.city}</p>
                <p className="mb-1">{invoice.data?.clientInfo?.zip}</p>
              </div>

              <div className="col-md-6 text-end">
                <p className="font-weight-bold mb-4">{t("payment_details")}</p>
                <p className="mb-1">
                  <span className="text-muted">{t("paymentMethod")}: </span>
                  {invoice.data?.paymentDetails?.paymentMethod}
                </p>
              </div>
            </div>

            <div className="row p-1">
              <h6
                className="text-align-center"
                style={{ textAlign: "center", color: "darkbrown" }}
              >
                PURCHASE DETAILS
              </h6>
              <div className="col-md-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="text-uppercase small font-weight-bold">
                        #
                      </th>
                      <th className="text-uppercase small font-weight-bold">
                        {t("package")}
                      </th>
                      <th className="text-uppercase small font-weight-bold">
                        {t("quantity")}
                      </th>
                      <th className="text-uppercase small font-weight-bold text-end">
                        {t("total")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice.data?.items?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.package}</td>
                        <td>{item.quantity}</td>
                        <td className="text-end">
                          {`${
                            userSelectedCurrency.symbolLeft
                          } ${CurrencyConverter(
                            item.amount,
                            conversionFactor
                          )}`}
                        </td>
                      </tr>
                    ))}

                    {invoice.data?.promocodeDetails ? (
                      <>
                        <tr>
                          <td colSpan={2}></td>
                          <td className="text-center"> Available Discount</td>
                          <td className="text-end">
                            -{" "}
                            {invoice.data?.promocodeDetails?.promo_code_amount}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}></td>
                          <td className="text-center">{t("grand_total")}</td>
                          <td className="text-end">
                            {" "}
                            {`${
                              userSelectedCurrency.symbolLeft
                            } ${CurrencyConverter(
                              invoice.data?.promocodeDetails?.final_amount,
                              conversionFactor
                            )}`}
                          </td>
                        </tr>
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={2}></td>
                          <td className="text-center">{t("grand_total")}</td>
                          <td className="text-end">
                            {" "}
                            {`${
                              userSelectedCurrency.symbolLeft
                            } ${CurrencyConverter(
                              invoice.data?.grandTotal,
                              conversionFactor
                            )}`}
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="d-flex flex-row-reverse text-white  p-4">
              <div className="py-1 px-1 text-end">
                {/* <div className="mb-2">{t("grand_total")}</div>
                <div className="h2 font-weight-light">
                  {`${userSelectedCurrency.symbolLeft} ${CurrencyConverter(
                    invoice.data?.grandTotal,
                    conversionFactor
                  )}`}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-8 m-auto mt-2">
          
          <div
          id="content-to-export"
            className="row"
            style={{ background: "white", border: "1px solid lightgrey" }}
          >
           
            <div
            
              className="message_text"
              style={{
                padding: "15px",
                background: "white",
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(invoice?.data?.agreementDetails, {
                  ALLOWED_ATTR: ["style", "class", "id"],
                  ALLOW_STYLE_TAGS: true,
                  ALLOW_STYLE_ATTR: true,
                  FORCE_BODY: true,
                }),
              }}
            />
            <div
              style={{
                marginTop: "30px",
                borderTop: "1px dashed #ccc",
                paddingTop: "15px",
              }}
            >
              <p>
                <strong>(Buyer):</strong>
              </p>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <p>
                    <img
                      style={{ width: "200px" }}
                      src={invoice.data?.clientInfo?.signature}
                    />
                  </p>
                  <p>Name: {invoice.data?.clientInfo?.name}</p>
                  <p>Date: {new Date().toLocaleDateString()}</p>
                </div>
                <div>
                    
                </div>
              </div>
             
            
             
            </div>
       
           
          </div>
          <div className="row">
            <button  className="col-md-8 m-auto mt-2" style={{background: "white",color:"blue",border:"1px solid darkgrey",textAlign:"center"}} onClick={downloadPDF}>Download Agreement</button>
          </div>
            
        </div>
      </div>
    </>
  );
};

export default PurchaseInvoice;
